import {postRequest} from '../../../../middlewares/api/actions';
import {getCsvTablePreviewUrl} from '../../../../constants/urls';

export const IMPORT_ATTRIBUTE_ROW_LIST_SHOW = 'IMPORT_ATTRIBUTE_ROW_LIST_SHOW';
export const IMPORT_ATTRIBUTE_ROW_LIST_HIDE = 'IMPORT_ATTRIBUTE_ROW_LIST_HIDE';
export const IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET = 'IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET';

export const showAttributeFileRowList = () => ({
  type: IMPORT_ATTRIBUTE_ROW_LIST_SHOW
});

export const hideAttributeFileRowList = () => ({
  type: IMPORT_ATTRIBUTE_ROW_LIST_HIDE
});

export const getAttributeFileRowListCsvRows = (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, tid, filePath) =>
  postRequest(
    IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET,
    getCsvTablePreviewUrl(separator, delimiter, true, filePath, tid, null),
    {
      PageNum: pageNum,
      PageSize: pageSize,
      FilterTable: filterTable,
      SortCols: sortCols,
      SortByDesc: sortByDesc,
    }
  );
